<template>
  <div id="app">
    <!-- <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link> -->
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import { getCookie, getUrlKey } from "@/utils/common";
import { getDeveloperBaseInfo } from "@/api/api_user";

export default {
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      successCode: Number(process.env.VUE_APP_SUCCESS_CODE)
    };
  },
  created() {
    console.log("init app" + location.href);
    const devId = getUrlKey("devId");
    console.log(devId);
    const sjt = getUrlKey("sjt");
    console.log(sjt);
    const transferId = getUrlKey("id");
    console.log(transferId);
    if (devId !== "" && sjt !== "") {
      sessionStorage.setItem("devId", devId);
      this.$store.commit("initDevId", { devId: devId });
      sessionStorage.setItem("sjt", sjt);
      this.$store.commit("initSjt", { sjt: sjt });
    }
    if (transferId !== "") {
      sessionStorage.setItem("transferId", transferId);
      this.$store.commit("initTransferId", { transferId: transferId });
    }
    this.initDevBaseInfo();
    this.initSider();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    initSider() {
      // 将路由设置为侧边栏
      console.log(this.$router.options.routes);
      const siderArr = [];
      this.$router.options.routes.forEach(element => {
        const siderTmp = {
          name: element.children[0].meta.title,
          path: element.redirect
        };
        siderArr.push(siderTmp);
      });
      this.siders = siderArr;
      this.$store.commit("setRoutes", { routes: siderArr });
    },
    async initDevBaseInfo() {
      const params = { devId: this.$store.state.devId };
      const res = await getDeveloperBaseInfo(params);
      console.log(res);
      if (res.code == this.successCode) {
        var devBaseInfo = res.data;
        this.$store.commit("initCompanyName", {
          companyName: devBaseInfo.companyName
        });
        this.$store.commit('initHasUnionPackageGame', {
          hasUnionPackageGame: devBaseInfo.hasUnionPackageGame
        })
      }
    }
  }
};
</script>
<style lang="scss"></style>
